import { format } from 'date-fns'
import { id } from 'date-fns/locale'

// by providing a default string of 'PP' or any of its variants for `formatStr`
// it will format dates in whichever way is appropriate to the locale
const formatDate = (dt: string | number | Date, fmt: string = 'PP') => {
  return format(dt, fmt, { locale: id })
}

const gradinFormat = (dt: string | number | Date, fmt: string = 'PP') => {
  const locale = window.navigator.language === 'id' ? id : undefined
  return format(dt, fmt, { locale })
}

export default {
  /**
   * Format date with given string format. Set locale to id
   * See https://date-fns.org/docs/format for accepted tokens
   */
  date: formatDate,
  dateLong: (dt: string | number | Date) => {
    return gradinFormat(dt, 'cccc, dd MMMM yyyy HH:mm')
  },
}
